export { default as CompleteInfoForm } from 'auth/components/form/CompleteInfoForm';
export { default as UpdateInfoForm } from 'auth/components/form/UpdateInfoForm';
export { default as LoginForm } from 'auth/components/form/LoginForm';
export { default as RecoverPasswordForm } from 'auth/components/form/RecoverPasswordForm';
export { default as ResetPasswordForm } from 'auth/components/form/ResetPasswordForm';
export { default as Wrapper } from 'auth/components/form/AuthFormWrapper';



// WEBPACK FOOTER //
// src/modules/auth/components/form/index.js